module.exports = __webpack_public_path__ + "static/media/patient.8f82ce30.svg";